<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="6"></Aide>

        <h3 class="titreSolu text-center">Déclaration</h3>

        <div v-if="idUserLingevres>0">
            <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
            </div>
            <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
                <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
            </div>

            <div>
                <div class="row">
                    <div class="col-6">
                        Date
                    </div>
                    <div class="col-6">
                        <input type="date" class="form-control" @change="getDeclaration()" v-model="date">
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        Heure départ
                    </div>
                    <div class="col-6">
                        <input v-if="verrouillage==0" type="time" class="form-control" v-model="heureDep">
                        <span v-if="verrouillage==1">{{heureDep}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        Heure arrivée
                    </div>
                    <div class="col-6">
                        <input v-if="verrouillage==0" type="time" class="form-control" v-model="heureArr">
                        <span v-if="verrouillage==1">{{heureArr}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        Ville départ
                    </div>
                    <div class="col-6">
                        <SearchAutocomplete v-if="verrouillage==0"
                                v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
                                v-bind:user="user" @input="inputD" @inputNom="inputNomD" v-bind:search="villeDepartNom"
                        />
                        <span v-if="verrouillage==1">{{villeDepartNom}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        Ville arrivée
                    </div>
                    <div class="col-6">
                        <SearchAutocomplete v-if="verrouillage==0"
                                v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
                                v-bind:user="user" @input="inputA" @inputNom="inputNomA" v-bind:search="villeArriveeNom"
                        />
                        <span v-if="verrouillage==1">{{villeArriveeNom}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        PDJ
                    </div>
                    <div class="col-6 text-center">
                        <input type="checkbox" v-if="verrouillage==0" v-model="pdj" value="1">
                        <span v-if="verrouillage==1">{{pdj}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        R. midi
                    </div>
                    <div class="col-6 text-center">
                        <input type="checkbox" v-if="verrouillage==0" v-model="rmidi" value="1">
                        <span v-if="verrouillage==1">{{rmidi}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        R. soir
                    </div>
                    <div class="col-6 text-center">
                        <input type="checkbox" v-if="verrouillage==0" v-model="rsoir" value="1">
                        <span v-if="verrouillage==1">{{rsoir}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        R. GD
                    </div>
                    <div class="col-6 text-center">
                        <input type="checkbox" v-if="verrouillage==0" v-model="rgd" value="1">
                        <span v-if="verrouillage==1">{{rgd}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        R. nuit
                    </div>
                    <div class="col-6 text-center">
                        <input type="checkbox" v-if="verrouillage==0" v-model="rnuit" value="1">
                        <span v-if="verrouillage==1">{{rnuit}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-6">
                        Retour voiture (en minute)
                    </div>
                    <div class="col-6 text-center">
                        <!--<input type="number" v-if="verrouillage==0" v-model="retourVoiture" value="0" class="form-control">-->
                        <select v-if="verrouillage==0" v-model="retourVoiture" class="form-control">
                            <option value="120">Caen - Tour</option>
                            <option value="120">Tour - Caen</option>
                            <option value="50">Vire - Caen</option>
                            <option value="50">Caen - Vire</option>
                        </select>
                        <span v-if="verrouillage==1">{{retourVoiture}}</span>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <button @click="save" class="btn btn-primary">Enregistrer</button>
                        &nbsp;
                        <button @click="deleteDeclaration" v-if="verrouillage==0 && idDeclaration!=null" class="btn btn-danger">Supprimer</button>
                    </div>
                </div>
            </div>
            <br/>
            <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
            </div>
            <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
                <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
            </div>
        </div>
        <div v-else>
            <div class="alert alert-danger" role="alert">
                Vous n'avez pas été trouvé dans la base de données de connexion. Merci de vous rapprocher de votre responsable.
            </div>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';
    import SearchAutocomplete from './SearchAutocomplete.vue'

    export default {
        name: "DeclarationChauffeur",
        props: ['token', 'site', 'user', 'racine', 'userId', 'systemeClient', 'idUser'],
        data() {
            return {
                errors: [], msgs: [], villeArrivee: null, villeDepart: null, date: null, heureDep: null, heureArr: null,
                pdj: null, rmidi: null, rsoir: null, rgd: null, rnuit: null, idUserLingevres: 0,
                verrouillage:0,villeDepartNom:'',villeArriveeNom:'',idDeclaration:null,retourVoiture:0,
                dateToday:null,
            };
        },
        methods:
            {
                tokenValide(json) {
                    if (json['status'] == '401') {
                        this.$emit('token')
                    }
                },
                inputD(input) {
                    console.log(input)
                    this.villeDepart = input
                },
                inputA(input) {
                    console.log(input)
                    this.villeArrivee = input
                },
                inputNomD(input) {
                    console.log(input)
                    this.villeDepartNom = input
                },
                inputNomA(input) {
                    console.log(input)
                    this.villeArriveeNom = input
                },
                save() {

                    if (this.villeDepart > 0 && this.date != null && this.heureDep != null) {

                        if (this.pdj == true) {
                            this.pdj = 1
                        }
                        else {
                            this.pdj = 0
                        }
                        if (this.rmidi == true) {
                            this.rmidi = 1
                        }
                        else {
                            this.rmidi = 0
                        }
                        if (this.rsoir == true) {
                            this.rsoir = 1
                        }
                        else {
                            this.rsoir = 0
                        }
                        if (this.rgd == true) {
                            this.rgd = 1
                        }
                        else {
                            this.rgd = 0
                        }
                        if (this.rnuit == true) {
                            this.rnuit = 1
                        }
                        else {
                            this.rnuit = 0
                        }
                        console.log("!!!"+this.heureArr)
                        if(this.heureArr==null)
                        {
                            this.heureArr = "00:00:00";
                        }
                        console.log("!!!"+this.heureArr)
                        if(this.villeArrivee==null)
                        {
                            this.villeArrivee = "0";
                        }

                        if(this.idDeclaration!=null)
                        {
                            fetch(this.racine + this.site + 'api/declaration_chauffeurs/'+this.idDeclaration, {
                                method: 'PUT',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + this.token
                                },
                                body: "{\"date\":\"" + this.date + "\"," +
                                "\"heureDepart\": \"" + this.heureDep + "\"," +
                                "\"heureArrivee\": \"" + this.heureArr + "\"," +
                                "\"villeDepartId\": " + this.villeDepart + "," +
                                "\"villeArriveeId\": " + this.villeArrivee + "," +
                                "\"pdj\": " + this.pdj + "," +
                                "\"rmidi\": " + this.rmidi + "," +
                                "\"rsoir\": " + this.rsoir + "," +
                                "\"rgd\": " + this.rgd + "," +
                                "\"userId\": " + this.idUserLingevres + "," +
                                "\"rnuit\": " + this.rnuit + "," +
                                "\"retourVoiture\": " + this.retourVoiture + "," +
                                "\"i\": 1," +
                                "\"interr\": 0," +
                                "\"amp\": \"00:00:00\"," +
                                "\"serv\": \"00:00:00\"," +
                                "\"cond\": \"00:00:00\"," +
                                "\"trav\": \"00:00:00\"," +
                                "\"coup\": \"00:00:00\"," +
                                "\"heureNuit\": \"00:00:00\"" +
                                "\"av\": \"00:00:00\"" +
                                "}"
                            }).then(response => response.json())
                                .then(json => {
                                    console.log(json);
                                    if (json['@type'] == "hydra:Error") {
                                        this.errors = []
                                        this.msgs = []
                                        this.errors.push("Un problème inconnu s'est produit.")
                                    }
                                    else if (json['id'] > 0) {
                                        this.msgs = []
                                        this.msgs.push("Votre déclaration a bien été prise en compte.")
                                        this.videDeclaration()
                                    }
                                    else {
                                        this.errors = []
                                        this.msgs = []
                                        this.errors.push("Un problème inconnu s'est produit.")
                                    }
                                })
                        }
                        else
                        {

                            fetch(this.racine + this.site + 'api/declaration_chauffeurs', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + this.token
                                },
                                body: "{\"date\":\"" + this.date + "\"," +
                                "\"heureDepart\": \"" + this.heureDep + "\"," +
                                "\"heureArrivee\": \"" + this.heureArr + "\"," +
                                "\"villeDepartId\": " + this.villeDepart + "," +
                                "\"villeArriveeId\": " + this.villeArrivee + "," +
                                "\"pdj\": " + this.pdj + "," +
                                "\"rmidi\": " + this.rmidi + "," +
                                "\"rsoir\": " + this.rsoir + "," +
                                "\"rgd\": " + this.rgd + "," +
                                "\"userId\": " + this.idUserLingevres + "," +
                                "\"retourVoiture\": " + this.retourVoiture + "," +
                                "\"rnuit\": " + this.rnuit + "," +
                                "\"interr\": 0," +
                                "\"i\": 1," +
                                "\"amp\": \"00:00:00\"," +
                                "\"serv\": \"00:00:00\"," +
                                "\"cond\": \"00:00:00\"," +
                                "\"trav\": \"00:00:00\"," +
                                "\"coup\": \"00:00:00\"," +
                                "\"heureNuit\": \"00:00:00\"," +
                                "\"av\": \"00:00:00\"," +
                                "\"created\": \""+this.dateToday+"\"" +
                                "}"
                            }).then(response => response.json())
                                .then(json => {
                                    console.log(json);
                                    if (json['@type'] == "hydra:Error") {
                                        this.errors = []
                                        this.msgs = []
                                        this.errors.push("Un problème inconnu s'est produit.")
                                    }
                                    else if (json['id'] > 0) {
                                        this.msgs = []
                                        this.msgs.push("Votre déclaration a bien été prise en compte.")
                                        this.videDeclaration()
                                    }
                                    else {
                                        this.errors = []
                                        this.msgs = []
                                        this.errors.push("Un problème inconnu s'est produit.")
                                    }
                                })
                        }

                    }
                    else
                    {
                        this.errors.push("Vous devez remplir tous les champs pour enregistrer.")
                    }

                },
                getUserLingevres() {
                    fetch(this.racine + this.site + 'api/get_id_user_lingevres/' + this.idUser, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.idUserLingevres = json['idUserLingevres']
                            }
                        })
                    })
                },
                getDeclaration() {
                    this.idDeclaration = null
                    fetch(this.racine + this.site + 'api/get_declaration_chauffeur_par_date/' + this.date+'/' + this.idUserLingevres, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                if(json['valide']==1) {
                                    console.log(json)
                                    this.date = json['date']
                                }
                                    this.heureDep = json['heureDepart']
                                    this.heureArr = json['heureArrivee']
                                    this.villeDepart = json['villeDepartId']
                                    this.villeArrivee = json['villeArriveeId']
                                    this.villeDepartNom = json['villeDepartNom']
                                    this.villeArriveeNom = json['villeArriveeNom']
                                    this.pdj = json['pdj']
                                    this.rmidi = json['rmidi']
                                    this.rsoir = json['rsoir']
                                    this.rgd = json['rgd']
                                    this.rnuit = json['rnuit']
                                    if(json['retourVoiture']!=null)
                                    {
                                        this.retourVoiture = json['retourVoiture']
                                    }
                                    else
                                    {
                                        this.retourVoiture = 0
                                    }
                                    this.idDeclaration = json['id']
                                    console.log(this.heureDep )
                                    console.log(this.villeDepart )

                            }
                        })
                    })
                },
                deleteDeclaration()
                {
                    if(this.idDeclaration!=null)
                    {
                        this.$bvModal.msgBoxConfirm('Etes vous sur de vouloir supprimer les données du '+this.date, {
                            title: 'Etes vous sûr?',
                            size: 'lg',
                            buttonSize: 'lg',
                            okVariant: 'danger',
                            okTitle: 'Oui',
                            cancelTitle: 'Non',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            noFade: true
                        })
                            .then(value => {
                                if (value == true) {
                                    console.log(value)
                                    fetch(this.racine + this.site + 'api/declaration_chauffeurs/'+this.idDeclaration, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        },
                                    }).then(response => {
                                        this.tokenValide(response)
                                        console.log(response)
                                        if(response.ok == true) {
                                            this.msgs = []
                                            this.msgs.push("La suppression de votre déclaration du " + this.date + " a bien été réalisée.")
                                            this.videDeclaration()
                                        }
                                    })
                                }})
                    }

                },
                videDeclaration()
                {
                    this.errors = []
                    this.villeDepartNom = ''
                    this.villeArriveeNom = ''
                    this.idDeclaration = null
                    this.date = null
                    this.heureDep = null
                    this.heureArr = null
                    this.villeDepart = null
                    this.villeArrivee = null
                    this.pdj = null
                    this.rmidi = null
                    this.rsoir = null
                    this.rgd = null
                    this.rnuit = null
                    this.retourVoiture = 0
                }
            },
        mounted() {
            this.getUserLingevres()
            var today = new Date()
            var month = today.getMonth() + 1
            var day = today.getDate()
            if (month < 10) {
                month = "0" + month
            }
            if (day < 10) {
                day = "0" + day
            }
            this.dateToday = today.getFullYear()+ '-' + month+'-' + day
        },
        created() {
        },
        components: {
            Aide,
            SearchAutocomplete,
        }
    }
</script>

<style scoped>

</style>